import { render, staticRenderFns } from "./ListDistributionCenterPackingLinkSpecialBranchTab.vue?vue&type=template&id=6286f315"
import script from "./ListDistributionCenterPackingLinkSpecialBranchTab.vue?vue&type=script&lang=js"
export * from "./ListDistributionCenterPackingLinkSpecialBranchTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports